import { getDenseModuleIds } from '../mapMarkerDensity'

describe('getDenseModuleIds', () => {
  it('marks both modules when their projected positions are close', () => {
    const dense = getDenseModuleIds(
      [
        { id: 1, lat: 50, lng: 10 },
        { id: 2, lat: 50, lng: 10.0001 },
        { id: 3, lat: 50, lng: 11 },
      ],
      17
    )

    expect([...dense].sort()).toEqual([1, 2])
  })

  it('marks modules close across the longitude wraparound', () => {
    const dense = getDenseModuleIds(
      [
        { id: 1, lat: 0, lng: 179.9999 },
        { id: 2, lat: 0, lng: -179.9999 },
      ],
      10
    )

    expect([...dense].sort()).toEqual([1, 2])
  })

  it('does not mark isolated modules', () => {
    expect(
      getDenseModuleIds(
        [
          { id: 1, lat: 0, lng: 0 },
          { id: 2, lat: 0, lng: 10 },
        ],
        14
      ).size
    ).toBe(0)
  })
})
